export { default } from './PrivateLocationMap.tsx';
